import { Component, ViewEncapsulation } from '@angular/core';
import { FullNavbarComponent } from '@portal-core/layout/components/full-navbar/full-navbar.component';
import { RouterOutlet } from '@angular/router';

@Component({
    selector: 'mc-full-page',
    templateUrl: './full-page.component.html',
    styleUrls: ['./full-page.component.scss'],
    encapsulation: ViewEncapsulation.None,
    imports: [FullNavbarComponent, RouterOutlet]
})
export class FullPageComponent {}
